import { TaskTypeFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Тип задачи — справочное значение, а не свободный текст: показывается локализованное
 * название элемента справочника, а не его код.
 */
export function TaskType({ data }: { data?: Hidable<TaskTypeFragment> }) {
  return (
    <Value data={data}>
      {(task) => <LocalizedName data={task.type.value} />}
    </Value>
  );
}
